import React, {useEffect, useState, useRef} from 'react';
import { useLocation } from "react-router-dom";
import {motion, AnimatePresence} from 'framer-motion';
import styled from 'styled-components';
import {gsap} from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Wave from './Wave'

import img0 from '../img/img-salon/IMG-20250204-WA0000.jpg'
import img4 from '../img/img-salon/IMG_4503.JPG'
import img5 from '../img/img-salon/IMG_4505.JPG'
import img6 from '../img/img-salon/IMG_4507.JPG'
import img7 from '../img/img-salon/IMG_4511.JPG'
import img8 from '../img/img-salon/IMG_4512.JPG'
import img9 from '../img/img-salon/IMG_4513.JPG'
import img10 from '../img/img-salon/IMG_4515.JPG'
import img11 from '../img/img-salon/IMG_4518.JPG'
import img12 from '../img/img-salon/IMG_4519.JPG'
import img13 from '../img/img-salon/IMG_4522.JPG'
import img14 from '../img/img-salon/IMG_4524.JPG'
import img15 from '../img/img-salon/IMG_4526.JPG'
import img16 from '../img/img-salon/IMG_4528.JPG'
import img17 from '../img/img-salon/IMG_4530.JPG'
import img1 from '../img/img-salon/IMG_4533.JPG'
import img2 from '../img/img-salon/IMG_4535.JPG'
import img3 from '../img/img-salon/IMG_4536.JPG'
import img21 from '../img/img-salon/IMG_4542.JPG'
import img22 from '../img/img-salon/IMG_4544.JPG'
import img23 from '../img/img-salon/IMG_4545.JPG'

const images = [img0,
                img1,
                img2,
                img3,
                img4,
                img5,
                img6,
                img7,
                img8,
                img9,
                img10,
                img11,
                img12,
                img13,
                img14,
                img15,
                img16,
                img17,
                img21,
                img22,
                img23];

gsap.registerPlugin(ScrollTrigger);

const AboutSection = () => {
    const [startIdx, setStartIdx] = useState(0);
    const [visibleCount, setVisibleCount] = useState(getVisibleCount());

    function getVisibleCount(){
        if (window.innerWidth < 768) return 1;
        if (window.innerWidth < 1024) return 2;
        return 3;
    }

    useEffect(() => {
        const handleResize = () => setVisibleCount(getVisibleCount());
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const prev = () => {setStartIdx((prevIdx) =>
        prevIdx === 0 ? images.length - 1 : prevIdx - 1)
    }

    const next = () => {setStartIdx((prevIdx) =>
       (prevIdx + 1) % images.length)
    }

    const visibleImages = [];
    for (let i = 0; i < visibleCount; i++){
        visibleImages.push(images[(startIdx + i) % images.length])
    }

    const handleDragEnd = (event, info) => {
        if (info.offset.x < -50){
            next();
        } else if (info.offset.x > 50){
            prev();
        }
    }

    const boxRef = useRef();
    const location = useLocation();

    useEffect(() => {
        gsap.to(boxRef.current, {
            scrollTrigger: {
                trigger: boxRef.current,
                start: "0%",
                end: "100%",
                pin: true,
                pinSpacing: false,
            }
        });
        // Cleanup on unmount
        return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }, [location.pathname]);

    return(
        <StyledAbout id='about'>
            <div className="carousel" ref={boxRef}>
                <AnimatePresence initial={false}>
                    <motion.div className = "carousel-track"
                      drag="x"
                      dragConstraints={{left: 0, right: 0}}
                      onDragEnd={handleDragEnd}
                      style={{touchAction:'pan-y'}}>
                        {visibleImages.map((img, idx) =>(
                            <motion.div
                              className="img-gallery-container"
                              key={img + '-' + idx + '-' + startIdx}
                              initial={{opacity: 0, x:30}}
                              animate={{opacity: 1, x: 0}}
                              exit= {{opacity: 0, y:-30}}
                              transition={{duration: 3}}
                              >
                                <img src={img} alt="" />
                            </motion.div>
                        ))}
                    </motion.div>
                </AnimatePresence>
                <div className="controls">
                    <button onClick={prev}>&lt;</button>
                    <button onClick={next}>&gt;</button>
                </div>
            </div>
            <div className="about-txt">
                <p>
                    Après avoir travaillé dans plusieurs salons de la région
                    parisienne, j’ai ouvert en 1998 le salon NICOLAS D Boulevard
                    St Marcel dans le 13° arrondissement.
                    Le salon a récemment été rénové en Août 2023 pour vous offrir
                    la meilleure expérience possible avec ma collaboratrice, et plus de 30 ans d'expertise.
                    Nous restons à votre service.
                    <br/>
                    <br/>
                    Nous travaillons avec les marques L’Oréal&reg; & Schwarzkopf&reg;.
                    <br/>
                    <br/>
                    Découvrez les prestations que nous proposons ainsi que leurs prix ci-dessous.
                    <br />
                    <br />
                    Prenez rendez-vous dès à présent sur notre site ou par téléphone (recommandé). Vous pouvez également vous présenter <em>sans réservation</em>.
                </p>
                <Wave hovered={true} color="#8f5c5cba"/>
            </div>
        </StyledAbout>
    )
}

const StyledAbout = styled(motion.section)`
    min-height: 100vh;
    display: flex;
    position: relative;
    flex-direction: column;

    .carousel{
        min-height: 85vh;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        background: white;
    }

    .carousel-track{
        display: flex;
    }

    .img-gallery-container{
        max-width: 50vw;
        height: 70vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .img-gallery-container img{
        width: 100%;
        height: 100%;
        display: block;
        padding: 0rem 1rem;
        object-fit: contain;
    }

    .controls{
        display: flex;
        width: 50%;
        justify-content: space-between;
    }

    .controls button{
        width: 36px;
        height: 36px;
        background: none;
        border-radius: 50%;
        border: none;
        color: black;
        font-size: 3rem;
        cursor: pointer;
    }

    .about-txt{
        z-index: 2;
        min-height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(45deg,rgba(15, 8, 8, 1) 45%, rgba(128, 128, 128, 1) 100%);
        padding: 3rem 20rem;
        p{
            color: white;
            font-size: 1.5rem;
            font-weight: 600;
            z-index: 2;
            line-height: 2.5rem;
        }
    }

    @media (max-width: 768px){
        .about-txt{
            padding: 0rem 2rem;
        }
        .img-gallery-container{
            height: 100vh;
            max-width: 100vw;
        }
        .controls{
            display: none;
        }
        
    }
`

export default AboutSection;